import { Observable } from 'rxjs';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Expense_Service } from './../../../services/Acc_Expense_Service';
import { Global } from '../../global';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { Txn_Expense } from '../../../models/Txn_Expense';
import { MatSnackBar } from '@angular/material';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import * as moment from 'jalali-moment';
import { DatePipe } from '@angular/common';
import { AccountMappingService } from '../../../services/AccountMappingService';
import * as $ from 'jquery';
import { DariCalendarService } from '../../../services/DariCalendar';


@Component({
  selector: 'app-expense-entry',
  templateUrl: './expense-entry.component.html',
  styleUrls: ['./expense-entry.component.css']
})
export class ExpenseEntryComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};

  GL_MastersDR: any;
  GL_MastersCR: any;

  GL_ChildsDR: any;
  GL_ChildsCR: any;

  selectedGL_Master_DR: "";
  selectedGL_Master_CR: "";
  ArrAccountMaps: any;


  txn_result: any;
  arr_results: any = {};
  //filteredOptions: Observable<string[]>;

  printVariables: any = {};

  Expense: Txn_Expense = {
    id: 0,
    GL_CR: "",
    GL_DR: "",
    expense_amount: 0,
    documentNo: "",
    expense_remark: "",
    authStat: "A",
    makerID: "test",
    checkerID: "test",
    trn_ref_no: "",
    value_date: new Date(),
    branchId: 0,
    statusId: 2,
    userId: '',
    branchTitle: '',
    statusTitle: '',
    addressExpFile: '',
    isPrint:false
  }

  pdate = moment(new Date()).format('jYYYY-jMM-jDD');    // Dari date

  constructor(
    private global: Global,
    private UtilityService: UtilityService,
    private GL_MasterService: GL_MasterService,
    private ExpenseService: Expense_Service,
    private DariCalendar: DariCalendarService,
    public snackBar: MatSnackBar,
    public datepipe: DatePipe,
    private AccountMapService: AccountMappingService
  ) { }

  ngOnInit() {
    this.getLabels();
    //this.getGlMasters();
    this.getBranchId();

    this.getGlChildsCR();
    this.getGlChildsDR();
    //let maps$:Observable<Object> = this.AccountMapService.getAccountMapping('expense-entry');

    //let gl_childs$:Observable<Object> = maps$.mergeMap(maps => {
    //  this.ArrAccountMaps = maps;
    //  //this.txn_CR.GL_Code = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice' &&  o.drcr === 'C' ).childAcc;
    //  this.selectedGL_Master_DR = this.ArrAccountMaps.find( (o:any) => o.component === 'expense-entry' &&  o.drcr === 'D'  && o.trnCode === 'AAT' ).masterAcc;

    //  return this.GL_MasterService.getGL_Childs(this.selectedGL_Master_DR);
    //})


    //gl_childs$.subscribe(ExpenseAccounts => {
    //  this.GL_ChildsDR = ExpenseAccounts;

    //})

    //console.log(`student accounts: ${this.GL_ChildsDR }`)
  }

  isDisabledMainBranch: boolean = false;
  isDisabledWestBranch: boolean = false;
  BranchId: number = -1;
  userId: string = "";
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/expense-entry")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch) {
        this.BranchId = 1;
        this.isDisabledWestBranch = true;
        this.isDisabledMainBranch = false;
      }
      else if (dataAccessUrl.isWestBranch) {
        this.BranchId = 2;
        this.isDisabledWestBranch = false;
        this.isDisabledMainBranch = true;
      }
      else {
        this.isDisabledWestBranch = false;
        this.isDisabledMainBranch = false;
        this.BranchId = 0;
      }
      this.userId = dataAccessUrl.userId
      console.log('userId:');
      console.log(this.userId);
    }
  }


  resetTrns() {
    this.Expense.expense_amount = 0;
    this.Expense.expense_remark = "";
    this.Expense.documentNo = "";
    this.Expense.trn_ref_no = "";
  }

  getGlMasters() {
    this.GL_MasterService.getGL_Masters("Cash_Bank", this.BranchId)
      .subscribe(response => {
        if (response) {
          this.GL_MastersCR = response;
        }
      },
        error => console.log("error --> " + error))


    this.GL_MasterService.getGL_Masters("Expense_Full", this.BranchId)
      .subscribe(response => {
        if (response) {
          this.GL_MastersDR = response;
        }
      },
        error => console.log("error --> " + error))




  }

  getGlChildsCR() {
     
    this.GL_MasterService.getGL_Childs("cash_bank", this.BranchId)
      .subscribe(response => {
        if (response) {
          this.GL_ChildsCR = response;
        }
      },
        error => console.log("error --> " + error))

  }

  getGlChildsDR() {
    this.GL_MasterService.getGL_Childs("expenses", this.BranchId)
      .subscribe(response => {
        if (response) {
          this.GL_ChildsDR = response;
        }
      },
        error => console.log("error --> " + error))

  }

  trnDateChanged(type: string, event: MatDatepickerInputEvent<Date>) {
    //console.log(`${type}: ${event.value}` );
    this.pdate = moment(event.value).format('jYYYY-jMM-jDD');
    this.Expense.value_date = moment(event.value).toDate();
  }

  openSnackBar(message: string, action: string) {
    console.log('snackbar --> ' + this.Expense.trn_ref_no);
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 5000,
    });
    snackBarRef.closeWithAction = function () {
      print();
      snackBarRef.dismiss();
    }
  }

  print(): void {
    alert('print');
  }


  @ViewChild("screenshotInput") screenshotInput: ElementRef;
  submit() {

     
    console.log(this.Expense);
    var gdate = new Date(this.datepipe.transform(this.Expense.value_date, 'yyyy-MM-dd'));
    this.Expense.value_date = `${gdate.getFullYear()}/${gdate.getMonth()+1}/${gdate.getDate()}`;
    this.Expense.userId = this.userId;
    this.Expense.branchId = this.BranchId;



    const fileInput: HTMLInputElement = this.screenshotInput.nativeElement;
    let filesList: any = fileInput.files;
    console.log("fileInput.files", fileInput.files);
    let dataExpence: Txn_Expense = this.Expense;

    const formData: FormData = new FormData();
    for (const key in dataExpence) {
      if (dataExpence.hasOwnProperty(key)) {
        formData.append(key, dataExpence[key]);
      }
    }
    formData.append('fileUpload', filesList[0]);


    this.ExpenseService.Create_Expense_Contract_File(formData)
      .subscribe(response => {
        if (response) {
          console.log(response);
          this.txn_result = response;
          this.arr_results['result'] = this.txn_result.find((o: any) => o.key === 'result').value;
          this.arr_results['trn_ref_no'] = this.txn_result.find((o: any) => o.key === 'trn_ref_no').value;
          let id: any = this.txn_result.find((o: any) => o.key === 'id').value;
           
          if (this.arr_results['result'] == 'success') {
            this.Expense.trn_ref_no = this.arr_results['trn_ref_no'];
            console.log('transaction succeed. trn_ref_no --> ' + this.Expense.trn_ref_no);


            let value :any = this.Expense;
            value.id = id;

            if (this.BranchId == 1)
              value.branchTitle = "شعبه مرکزی";
            else if (this.BranchId == 2)
              value.branchTitle = "شعبه غرب";
            value.GL_DR = this.Expense.GL_DR;
            value.GL_CR = this.Expense.GL_CR;
            value.expense_GL_DR = this.GL_ChildsDR.find(f => f.gL_ChildCode == this.Expense.GL_DR).gL_ChildDescFull;
            value.expense_GL_CR = this.GL_ChildsCR.find(f => f.gL_ChildCode == this.Expense.GL_CR).gL_ChildDescFull;
            
            this.printVariables['exp_id'] = value.id;
            this.printVariables['exp_DR'] = value.expense_GL_DR;
            this.printVariables['exp_CR'] = value.expense_GL_CR;
            this.printVariables['exp_DR_Code'] = value.GL_DR;
            this.printVariables['exp_CR_Code'] = value.GL_CR;
            this.printVariables['exp_branch'] = value.branchTitle;
            this.printVariables['exp_amount'] = value.expense_amount;
            this.printVariables['exp_docid'] = value.documentNo;
            this.printVariables['exp_desc'] = value.expense_remark;
            this.printVariables['exp_date'] = this.DariCalendar.PersianCalendar(new Date(value.value_date));
           
            let snackBarRef = this.snackBar.open(this.arr_results['trn_ref_no'], "چاپ", {
              duration: 10000,
            });
            snackBarRef.dismissWithAction = () => {
              this.getPrintRecord()
            }



            //  function () {
            //   
            //  ;
            //  //-------------------------------------------
            //  snackBarRef.dismiss();
            //  that.resetTrns();  
            //}
          }
          else {
            console.log('transaction failed: ' + this.arr_results['result']);
            this.openSnackBar(this.arr_results['result'], '');
          }
        }

      },
        error => console.log(error));
  }


  getPrintRecord() {
     

    setTimeout(() => {



      var content = $("#print-section").prop('outerHTML');
      var printWindow = window.open('', '', '');
      printWindow.document.write('<html><head><title>Print</title>');
      var _link = $('link');
      var _style = $('style');
      var strstyle = '';
      var _script = $('script');
      for (var k = 0; k < _link.length; k++)
        printWindow.document.write(_link[k].outerHTML);
      for (var i = 0; i < _style.length; i++)
        printWindow.document.write(_style[i].outerHTML);
      for (var j = 0; j < _script.length; j++)
        printWindow.document.write(_script[j].outerHTML);
      printWindow.document.write('</head><body  style="-webkit-print-color-adjust: exact;     margin-top: 1px;"  >');
      printWindow.document.write(content);
      printWindow.document.write('<script> $(".AES").css("display", "block");</script> </body ></html>');
      printWindow.document.close();

      this.resetTrns();
    }, 1000)
  }



  getLabels() {
    this.UtilityService.getLabels('expense-entry', this.global.lang)
      .subscribe(response => {
        if (response) {
          this.ArrLabels = response;
          this.setLabels();
        }
      },
        error => console.log(error))
  }

  setLabels() {
    //title
    this.labels['expense-entry-Title'] = this.ArrLabels.find((o: any) => o.key === 'expense-entry-Title').value;

    // labels
    this.labels['DebitSide'] = this.ArrLabels.find((o: any) => o.key === 'DebitSide').value;
    this.labels['CreditSide'] = this.ArrLabels.find((o: any) => o.key === 'CreditSide').value;

    this.labels['GL_Master'] = this.ArrLabels.find((o: any) => o.key === 'GL_Master').value;
    this.labels['DebitAccount'] = this.ArrLabels.find((o: any) => o.key === 'DebitAccount').value;
    this.labels['CreditAccount'] = this.ArrLabels.find((o: any) => o.key === 'CreditAccount').value;
    this.labels['ValueDate'] = this.ArrLabels.find((o: any) => o.key === 'ValueDate').value;
    this.labels['TrnAmount'] = this.ArrLabels.find((o: any) => o.key === 'TrnAmount').value;
    this.labels['trnRemakrs'] = this.ArrLabels.find((o: any) => o.key === 'trnRemakrs').value;
    this.labels['DocumentNo'] = this.ArrLabels.find((o: any) => o.key === 'DocumentNo').value;
    // Alerts
    this.labels['DocumentNoMandatory'] = this.ArrLabels.find((o: any) => o.key === 'DocumentNoMandatory').value;

    // shared labels.

  }
}



// WEBPACK FOOTER //
// ./src/app/components/TRNs/expense-entry/expense-entry.component.ts